import { NOTIFICATON_LEVELS } from '../../constants';
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION } from './actionTypes';

const AUTO_HIDE_DURATION = 3000;

export const addNotification = (
  message,
  level = NOTIFICATON_LEVELS.INFO,
  sticky = false,
) => ({
  type: ADD_NOTIFICATION,
  notification: {
    message,
    options: {
      variant: level,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      autoHideDuration: AUTO_HIDE_DURATION,
      persist: sticky,
    },
    key: new Date().getTime() + Math.random(),
  },
});

export const removeNotification = key => ({
  type: REMOVE_NOTIFICATION,
  key,
});
